import React from 'react';
import PropTypes from 'prop-types';
const sortBy = require('lodash/sortBy');

const Globals = require('../../../../../app/globals');
import ActionListItem from './ActionListIem';

const propTypes = {
    inSlide: PropTypes.bool,
    actions: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })),
    hideMenu: PropTypes.func,
};

const defaultProps = {
    inSlide: false,
    actions: [],
    hideMenu: null
};

function SideMenu(props) {
    function handleAction(action) {
        if (props.hideMenu) props.hideMenu();
        if (action) action();
    }

    return (
        <div className={`side-menu ${props.inSlide ? 'in-slide' : ''} mzl-cs-nav db3SideMenu`}>
            <div className="nav-list action-list db3NavActionList">
                {sortBy(props.actions, "group").map((action) => 
                    <ActionListItem
                        key={action.id}
                        onClick={handleAction.bind(null, action.onClick)}
                        extraClasses={action.extraClasses}
                        iconClass={action.iconClass}
                        text={action.text}
                        active={action.active}
                    />
                )}
            </div>
        </div>
    );
}

SideMenu.propTypes = propTypes;
SideMenu.defaultProps = defaultProps;

export default SideMenu;
